<template>
  <div class="ui-pop" v-show="show">
    <div class="ui-mask"></div>
    <div class="ui-modal large scroll">
      <p class="modal-title">{{ $t('FAQs') }}</p>
      <a class="modal-close" @click="closePop"><i class="el-icon-close"></i></a>
      <div class="content terms">
        <div v-for="(item, index) in content" :key="index">
          <p v-html="item.title"></p>
          <p v-html="item.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// $i18n.locale === 'en'
import { getArticleList, getArticle } from '@/service/api.js'
export default {
  data() {
    return {
      content: [],
    }
  },
  props: ['show'],
  watch: {
    '$i18n.locale'(language) {
      console.log(language);
      if(['cn','en','TW'].includes(this.$i18n.locale)){
        this.getArticleListData()
      }
    },
  },
  methods: {
    closePop() {
      this.$parent.showFaq = false
    },
    async getArticleListData() {
      // console.log(this.$i18n.locale);
      let arr = []
      let categoryId;
      if (this.$i18n.locale === 'cn') {
        categoryId = 28;
      } else if (this.$i18n.locale === 'en') {
        categoryId = 29;
      } else if (this.$i18n.locale === 'TW') {
        categoryId = 36;
      }
      this.content=[];
      const res = await getArticleList({
        pageNO: 1,
        pageSize: 9999,
        categoryId,
      })
      if (res.data.status === 1) {
        if (res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            this.content.push(item)
          })
        }
      }
    },
  },
  mounted() {
    this.getArticleListData()
  },
}
</script>
<style lang="scss" scoped>
.terms {
  padding: 50px;
  font-size: 14px;
  line-height: 1.5;
  p {
    margin-top: 20px;
  }
}
@media screen and (max-width: 768px) {
  .terms {
    padding: 20px;
  }
}
</style>